const BindingScopeEnum = {
    Singleton: "Singleton",
    Transient: "Transient"
}, BindingTypeEnum = {
    ConstantValue: "ConstantValue",
    Constructor: "Constructor",
    DynamicValue: "DynamicValue",
    Factory: "Factory",
    Function: "Function",
    Instance: "Instance",
    Invalid: "Invalid",
    Provider: "Provider"
}, TargetTypeEnum = {
    ClassProperty: "ClassProperty",
    ConstructorArgument: "ConstructorArgument",
    Variable: "Variable"
};

export { BindingScopeEnum, BindingTypeEnum, TargetTypeEnum };
//# sourceMappingURL=literal_types.js.map
